export const scaleParser = scale => scale;
//# sourceMappingURL=scale.js.map
